import {hasSeatingPlan, isAvailableDonationTicket, isRegistrationClosedVisible} from '@wix/wix-events-commons-statics'
import {State} from '../types/state'
import {getEvent} from './event'

export const ticketDescriptionExpanded = (state: State, ticketDefId: string) =>
  Boolean(state.ticketsPicker.tickets?.[ticketDefId]?.expandedDescription)

export const isDonationInputVisible = (state: State, ticket: wix.events.ticketing.TicketDefinition) =>
  isAvailableDonationTicket(ticket) && !isRegistrationClosedVisible(getEvent(state)) && !hasSeatingPlan(getEvent(state))
